import { Stack, Typography } from '@mui/material';
import { find } from 'lodash';
import { Check } from '@mui/icons-material';

interface ISizeLabelProps {
  sizes: Array<string>;
}

const sizes = ['xs', 's', 'm', 'l', 'xl'];
export const SizeLabel = (props: ISizeLabelProps) => {
  return (
    <Stack
      direction="row"
      width={'100%'}
      alignContent={'space-evenly'}
      justifyContent={'space-evenly'}
    >
      {sizes.map((s) => (
        <Stack key={s} direction={'column'} alignItems={'center'}>
          <Typography variant="body1" color="secondary" fontWeight="bold">
            {s.toUpperCase()}
          </Typography>
          {find(props.sizes, (f) => f == s) && (
            <Check color="primary" fontSize="small" />
          )}
        </Stack>
      ))}
    </Stack>
  );
};
